import dom from "../../../dist/jsx-render/dom"
import { ColumnBase } from "./ColumnBase";
import { TextComponent } from "../../Components/TextComponent";
import { MsoTable } from "./MsoTable";
import { ITableColumn } from "./ITableColumn";
import { ColorHelper } from "../ColorHelper";
import { LanguageString } from "../../Model/LanguageString";
import { app } from "../../Frame/App";

export class ColumnString extends ColumnBase {

    public constructor(table: MsoTable, def: ITableColumn, protected rootId: string) {
        super(table, def, rootId);

        if (this.isEditable) {
            this.recreateCellOnUpdate = true;
        }
    }

    get isEditableCategory(): boolean {
        return this.isEditable && this.field && this.field.startsWith("CAT#");
    }

    getCellClass(): string {
        if (this.isEditable) {
            return super.getCellClass() + " mt-textedit";
        }
        else {
            return super.getCellClass();
        }
    }

    public isFilterVisible(model: any): boolean {
        if (!this.filteredItems)
            return true;

        const value = model[this.field];

        if (value && value.trim() == "")
            return false;

        if (value) {
            if (value.trim() in this.filteredItems) {
                return true;
            }

            const items = value.split(',');

            for (let i in items) {
                if (items[i].trim() in this.filteredItems)
                    return true;
            }
        }

        return value in this.filteredItems;
    }

    public createCell(rowModel: any, idField: string): HTMLElement {
        let cell = super.createCell(rowModel, idField);

        if (this.isEditableCategory) {
            cell.classList.add("dropdown");
            cell.classList.add("align-items-stretch");

            this.table.inlineEdit.createDropdown(cell, rowModel, idField, this.field);
        }

        return cell;
    }

    updateCell(cell: HTMLElement, model: any): HTMLElement {
        cell = super.updateCell(cell, model);

        if (this.isEditableCategory) {
            this.table.inlineEdit.createDropdown(cell, model, this.table.props.idField, this.field);
        }
        return cell;
    }

    public getContent(row: any): HTMLElement {
        let element: HTMLElement;

        if (this.isEditable && !this.isEditableCategory) {
            let textComp = new TextComponent({
                field: this.field,
                model: row,
                disabled: this.def.isDisabled,
                createFormGroup: false,
                changeEvent: () => {
                    if (this.table.props.onModelChanged) {
                        this.table.props.onModelChanged(this.field, row);
                    }
                }
            });
            element = textComp.render();
        }
        else if (!this.isEditLink && this.def.dataField.startsWith("CAT#")) {
            const content = row[this.def.dataField] ?? '\u00A0';
            let span: HTMLElement = <span>{content}</span>;
            span.style.textOverflow = "inherit";
            span.style.overflow = "hidden";

            element = <span>{span}</span>;
        }
        else if (!this.isEditLink && this.def.htmlEncode == false) {
            const content = row[this.def.dataField] ?? '\u00A0';
            element = <div></div>;
            element.innerHTML = content;
        }
        else {
            // Use own implementation here to account for the possibility of content being a language string
            let content = row[this.def.dataField] ?? '\u00A0';

            if (content instanceof LanguageString) {
                content = content.getForLanguage(app.language);
            }

            if (this.isEditLink) {
                const link: HTMLElement = <a className="mt-link" href="#"><span>{content}</span></a>;

                if (this.table.props.onEditIconClicked) {
                    link.addEventListener("click", () => {
                        this.table.props.onEditIconClicked(this.field, row);
                    });
                }

                let color = row[this.getCorrespondingColorColumnName()] as string;
                return this.getElementWithColorItemProperties(link, color);;
            }
            else {
                let spanElement = <span>{content}</span>;

                let color = row[this.getCorrespondingColorColumnName()] as string;
                return this.getElementWithColorItemProperties(spanElement, color);
            }
        }

        let color = row[this.getCorrespondingColorColumnName()] as string;
        return this.getElementWithColorItemProperties(element, color);
    }

    /**Generate the corresponding color column name */
    private getCorrespondingColorColumnName = (): string => {
        return "COLOR-ITM#" + this.def.dataField.substring(this.def.dataField.indexOf('#') + 1);
    }

    /**Applies coloerd background on the element if a coloe is available */
    private getElementWithColorItemProperties = (element: HTMLElement, color: string): HTMLElement => {
        if (color) {
            element.style.display = "flex";
            element.style.alignItems = "center";
            element.style.width = "100%";
            element.style.height = "100%";
            element.style.paddingLeft = ".5rem";
            element.style.borderRadius = ".4rem";

            element.style.backgroundColor = color;
            element.style.color = ColorHelper.getContrastingTextColor(color);
        }

        return element;
    }
}